// extracted by mini-css-extract-plugin
export default {"container":"Menu_container__mtPog","active":"Menu_active__uN5fB","wrapper":"Menu_wrapper__jS2FI","icon":"Menu_icon__-7FcF","title":"Menu_title__yM6J7"};